/* eslint-disable no-eval */
/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from "api";
import classNames from "classnames";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { SimpleMaskInputField } from "components/InputsMex/SimpleInputs";
import { urlEmisionPoliza } from "constants/urls";
import { TextInput as TextInputX } from "containers/Pymes/componentes/entradas";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router";
import { evaluate } from "utils/eval";
import { getQueryParams } from "utils/funciones";
import {
  DropDown,
  DropDownDate,
  DropDownFilter,
  PrimeTextInput,
  TextInput,
} from "../InputsMex/inputs";

const process = (rules, resources) => {
  if (rules && typeof rules === "object") {
    if (rules?.validate) {
      const { validate } = rules;
      if (typeof validate === "object") {
        const entries = Object.entries(rules?.validate);
        if (entries.length > 0) {
          entries.forEach(([key, value]) => {
            if (typeof value === "string") {
              const validation = evaluate(value);
              rules.validate[key] = async (val) => {
                return await validation(val, resources);
              };
            }
          });
        }
      } else if (typeof validate === "string") {
        const validation = evaluate(rules.validate);

        rules.validate = async (value) => await validation(value, resources);
      }
    }

    if (rules.pattern && rules.pattern.value && typeof rules.pattern.value === "string") {
      rules.pattern.value = new RegExp(rules.pattern.value);
    }
    return rules;
  }
  return {};
};

export const validarFechasMinMaxFixed = ({
  min,
  max,
  fixed,
  valueMoment,
  msgMin,
  msgMax,
  msgFixed,
  msgMinMax,
}) => {
  if (min && max) {
    const fechaMin = moment().subtract(min.value, min.unit);
    const fechaMax = moment().subtract(max.value, max.unit);
    const isValidMin = valueMoment.isBefore(fechaMin);
    const isValidMax = valueMoment.isAfter(fechaMax);

    if (isValidMin && isValidMax) {
      return true;
    }
    return msgMinMax?.(fechaMin, fechaMax);
  }

  if (min) {
    const fecha = moment().subtract(min.value, min.unit);
    const isValid = valueMoment.isBefore(fecha);
    if (!isValid) {
      return msgMin?.(fecha);
    }
  }
  if (max) {
    const date = moment(max?.value, "yyyy-MM-DD");
    if (typeof max?.value === "string" && !max.unit && date.isValid()) {
      const isValidBefore = valueMoment.isBefore(date);
      const isValidSame = valueMoment.isBefore(date);
      if (isValidBefore || isValidSame) {
        return true;
      }
      return msgMax?.(date);
    }
    const fecha = moment().subtract(max.value, max.unit);
    const isValid = valueMoment.isAfter(fecha);
    if (!isValid) {
      return msgMax?.(fecha);
    }
  }
  if (fixed) {
    const leadMoment = moment().subtract(fixed.value, "years");
    const anioActual = moment().diff(leadMoment, "years", true);
    const anioReact = moment().diff(valueMoment, "years", true);

    const isValid = Math.floor(anioActual) === Math.floor(anioReact);

    if (isValid) {
      return true;
    }
    return msgFixed?.();
  }

  return true;
};

const processProps = (stringCode = "", resources) => {
  if (!stringCode || stringCode.trim() === "") {
    return {};
  }
  const getProps = evaluate(stringCode);

  return getProps(resources);
};
const SwitchFormContratanteAsegurado = ({
  campos = [],
  catalogo,
  onChanges,
  loadings,
  sources,
  producto,
  formulario,
}) => {
  const methods = useFormContext();
  const toasts = useCustomToast();

  const qParams = useQueryParams();
  const params = useParams();
  const [components, setComponents] = useState([]);
  const [municipios, setMunicipios] = useState(sources?.municipios);
  const [colonias, setColonias] = useState(sources?.colonias);

  const [loadingCodigoPostal, setLoadingCodigoPostal] = useState(false);

  useEffect(() => {
    setMunicipios(sources?.municipios);
  }, [sources?.municipios]);

  useEffect(() => {
    setColonias(sources?.colonias);
  }, [sources?.colonias]);

  const { watch } = methods;

  const buscarPorCodigoPostal = async () => {
    const isValid = await methods.trigger("codigoPostal");

    if (isValid) {
      const codigoPostal = methods.getValues("codigoPostal");

      methods.setValue("estado", null);
      methods.setValue("municipio", null);
      methods.setValue("colonia", null);
      setLoadingCodigoPostal(true);

      const Data = {
        datosCotizador: {
          prodCodigo: producto,
          cotPasoCodigo: "codigoPostal",
          codigoPostal: codigoPostal,
        },
      };
      const res = await consumirServicioEncirptacion(urlEmisionPoliza, Data);

      if (res.transaccion && res?.catalogo?.codPostalRespuesta) {
        const response = res?.catalogo?.codPostalRespuesta;
        if (response?.municipio?.listado) {
          if (response?.estado?.value) {
            methods.clearErrors("estado");
            methods.setValue("estado", response?.estado?.value);
          }
          setMunicipios(response.municipio.listado);
          if (response.municipio?.value) {
            methods.clearErrors("municipio");
            methods.setValue("municipio", response.municipio?.value);
          }
          setColonias(response.colonia.listado);
          if (response?.colonia?.value) {
            methods.clearErrors("colonia");
            methods.setValue("colonia", null);
          }
        } else {
          methods.setError("codigoPostal", {
            type: "custom",
            message: "No se han encontrado resultados",
          });
          //toasts.addWarningToast('No se han encontrado resultados');
        }
      } else {
        methods.setError("codigoPostal", {
          type: "custom",
          message: "No se han encontrado resultados",
        });
      }
      setLoadingCodigoPostal(false);
    }
  };

  useEffect(() => {
    setComponents(
      campos.map((item, index) => {
        let campo = item;
        if (campo?.validationCriteria === "onSubmit") {
          campo.rules = {};
        }

        const resources = {
          methods,
          toasts,
          moment,
          React,
          catalogo,
          qParams,
          params,
          sources,
          formulario,
          validarFechasMinMaxFixed,
          buscarPorCodigoPostal,
          getQueryParams,
        };

        campo.rules = process({ ...campo?.rules, ...campo?.onSubmitRules }, resources);

        if (campo.customProps) {
          campo = {
            ...campo,
            ...processProps(campo.customProps, resources),
          };
        }

        if (
          (campo.validateShowIf &&
            !catalogo.camposAdicionales.mostrarCamposTipoPersona) ||
          (campo.hasOwnProperty("producto") && campo.producto !== producto) ||
          (campo.hasOwnProperty("formulario") && campo.formulario !== formulario)
        ) {
          return null;
        }

        if (campo.name === "codigoPostal") {
          return (
            <div
              className={classNames("form-group col-md-6 col-lg-5", {
                "d-none": campo.hide,
              })}
              key={index}>
              <SimpleContainer
                label={campo.label}
                name='codigoPostal'
                helpText={loadingCodigoPostal && "Buscando..."}
                subLabel={
                  <button
                    className='btn btn-primary btn-sm'
                    style={{ padding: "2px 7px", margin: "0" }}
                    disabled={loadingCodigoPostal}
                    type='button'
                    onClick={buscarPorCodigoPostal}>
                    <i className='pi pi-search' style={{ fontSize: "15px" }} />
                  </button>
                }
                {...campo.containerProps}>
                <PrimeTextInput
                  name='codigoPostal'
                  rules={campo.rules}
                  disabled={loadingCodigoPostal}
                  {...campo.inputProps}
                />
              </SimpleContainer>
            </div>
          );
        }

        if (campo.showOn.includes(watch("tipoPersona")?.value)) {
          switch (campo.type) {
            case "mask":
              return <MaskInputField key={index} {...campo} sources={sources} />;
            case "text":
            case "string":
              return <TextInputField key={index} {...campo} sources={sources} />;
            case "number":
              if (campo.isNumberInt) {
                return <NumberIntInputField key={index} {...campo} />;
              }
              return <NumberInputField key={index} {...campo} />;
            case "date":
              return <DropDownDateInputField key={index} {...campo} />;

            case "select":
              return (
                <DropDownInputField
                  key={index}
                  options={catalogo[campo.source]?.map((e) => ({
                    label: e.label,
                    value: e,
                  }))}
                  {...campo}
                />
              );
            case "custom-select":
              return <DropDownInputField key={index} {...campo} />;

            case "custom":
              switch (campo.name) {
                case "gastoEstimadoAnual":
                  return (
                    <div key={index} className='row justify-content-between w-100 ml-1'>
                      <DropDownInputField
                        {...campo.dropdownProps}
                        name={campo?.name + "." + campo?.dropdownProps?.name}
                      />

                      {watch(campo?.name + "." + campo?.dropdownProps?.name) === "SI" && (
                        <MaskCurrency
                          {...campo.inputProps}
                          name={campo?.name + "." + campo?.inputProps?.name}
                          sources={sources}
                          rules={{
                            ...process(campo?.inputProps?.rules, resources),
                          }}
                        />
                      )}
                    </div>
                  );
                case "estado":
                  return (
                    <div
                      className={classNames("form-group col-md-6 col-lg-5", {
                        "d-none": campo.hide,
                      })}
                      key={index}>
                      <SimpleContainer
                        label={campo?.label}
                        name='estado'
                        helpText={campo.helpText}>
                        <DropDownFilter
                          name='estado'
                          optionLabel='label'
                          optionValue='value'
                          onChangeFn={(value) => {
                            onChanges.onChangeEstado(value);
                          }}
                          options={catalogo?.estados?.map((e) => ({
                            label: e.label,
                            value: e,
                          }))}
                          loading={loadingCodigoPostal}
                          rules={campo.rules}
                          {...campo.containerProps}
                        />
                      </SimpleContainer>
                    </div>
                  );

                case "colonia":
                  return (
                    <div
                      className={classNames("form-group col-md-6 col-lg-5", {
                        "d-none": campo.hide,
                      })}
                      key={index}>
                      <SimpleContainer
                        label={campo.label}
                        name='colonia'
                        helpText={campo.helpText}>
                        <DropDownFilter
                          name='colonia'
                          optionLabel='label'
                          optionValue='value'
                          //dataKey="value"
                          onChangeFn={(value) => {
                            onChanges.onChangeColonia(value);
                          }}
                          options={colonias}
                          loading={loadings.loadingColonias || loadingCodigoPostal}
                          rules={campo.rules}
                          {...campo.containerProps}
                        />
                      </SimpleContainer>
                    </div>
                  );
                case "municipio":
                  return (
                    <div
                      className={classNames("form-group col-md-6 col-lg-5", {
                        "d-none": campo.hide,
                      })}
                      key={index}>
                      <SimpleContainer
                        label={campo.label}
                        name='municipio'
                        helpText={campo.helpText}>
                        <DropDownFilter
                          name='municipio'
                          //placeholder="Seleccionar un municipio (antes seleccionar un estado)"

                          optionLabel='label'
                          optionValue='value'
                          onChangeFn={(value) => {
                            onChanges.onChangeMunicipio(value);
                          }}
                          loading={loadings.loadingMunicipios || loadingCodigoPostal}
                          options={municipios}
                          rules={campo.rules}
                          {...campo.containerProps}
                        />
                      </SimpleContainer>
                    </div>
                  );

                default:
                  return null;
              }

            default:
              return null;
          }
        }
        return null;
      })
    );
  }, [watch("tipoPersona"), sources, loadingCodigoPostal, loadings]);

  return components;
};

export default SwitchFormContratanteAsegurado;

const TextInputField = ({
  name,
  label,
  rules,
  disabled = false,
  sources,
  helpText,
  ...rest
}) => {
  const { setValue, control } = useFormContext();

  const value = useWatch({ name, control });

  useEffect(() => {
    if ((!value || value === "") && rest?.preload) {
      const defaultValue = _.get(
        sources,
        rest?.preload?.sourcePath,
        rest?.preload?.defaultValue
      );
      setValue(name, defaultValue);
    }
  }, []);

  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name} helpText={helpText} info={rest?.info}>
        <TextInput inputProps={{ name, readOnly: disabled }} rules={rules} />
      </SimpleContainer>
    </div>
  );
};

const NumberIntInputField = ({ name, label, rules, helpText, ...rest }) => {
  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name} helpText={helpText}>
        <TextInput inputProps={{ name, isNumberInt: true }} hideArrows rules={rules} />
      </SimpleContainer>
    </div>
  );
};

const NumberInputField = ({ name, label, rules, helpText, ...rest }) => {
  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name} helpText={helpText}>
        <TextInput inputProps={{ name }} rules={rules} />
      </SimpleContainer>
    </div>
  );
};

const DropDownDateInputField = ({ name, label, rules, helpText, ...rest }) => {
  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name} helpText={helpText}>
        <DropDownDate name={name} rules={rules} {...rest} />
      </SimpleContainer>
    </div>
  );
};

const DropDownInputField = ({
  name,
  label,
  rules,
  onChangeFn,
  options,
  defaultValue,
  helpText,
  ...rest
}) => {
  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name} helpText={helpText}>
        <DropDown
          name={name}
          optionLabel='label'
          optionValue='value'
          defaultValue={defaultValue}
          onChangeFn={onChangeFn}
          options={options}
          rules={rules}
          {...rest}
        />
      </SimpleContainer>
    </div>
  );
};

const MaskInputField = ({ sources, ...rest }) => {
  const { name } = rest;
  const { control, setValue } = useFormContext();
  const value = useWatch({ name, control });

  useEffect(() => {
    if ((!value || value === "") && rest?.preload) {
      const defaultValue = _.get(
        sources,
        rest?.preload?.sourcePath,
        rest?.preload?.defaultValue
      );
      setValue(name, defaultValue);
    }
  }, []);

  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleMaskInputField {...rest} />
    </div>
  );
};

const MaskCurrency = ({ sources, ...rest }) => {
  const { name, label } = rest;
  return (
    <div
      className={classNames("form-group col-md-6 col-lg-5", {
        "d-none": rest.hide,
      })}>
      <SimpleContainer label={label} name={name}>
        <TextInputX
          inputProps={{
            name,
            type: "number",
          }}
          numerico={true}
          extrasClasses='hide-arrows'
          {...rest}
        />
      </SimpleContainer>
    </div>
  );
};
